import { render } from "./ConfirmationDialog.vue?vue&type=template&id=9f227ba6"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"

import "./ConfirmationDialog.vue?vue&type=style&index=0&id=9f227ba6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__